/* src/app/warehousing/partials/product-group-form/product-group-form.component.scss */
/*# sourceMappingURL=product-group-form.component.css.map */
